import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { shiftTransferDtoSchema } from "../types";

export const createShiftTransferResponseSchema = z.object({
  data: shiftTransferDtoSchema.optional(),
});
export type CreateShiftTransferResponse = z.infer<typeof createShiftTransferResponseSchema>;

export const createShiftTransferRequestSchema = z.object({
  toWorkerId: z.string(),
});
export type CreateShiftTransferPayload = z.infer<typeof createShiftTransferRequestSchema>;

export function useCreateShiftTransfer() {
  return useMutation({
    mutationFn: async (values: { shiftId: string; payload: CreateShiftTransferPayload }) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/shifts/${values.shiftId}/transfers`,
        data: values.payload,
        requestSchema: createShiftTransferRequestSchema,
        responseSchema: createShiftTransferResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_SHIFT_TRANSFER_FAILURE,
    },
  });
}
